export enum Mode {
    // discover
    searches,
    targetingLists,
    privateContacts,
    distributions,
    hidden,
    discoverContacts,
    // monitoring
    mentions,
    topics,
    briefings,
    alerts,
    mediaSubscriptions,
    reports,
    newSearch,

    // newsroom
    newsroom,

    // newswire+
    wire,
    editorial,

    // admin
    account,
    user,

    // monitoring - automation agents
    automationAgents,

    // visibility intelligence
    visibilityIntelligence
}
